import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-5',
  templateUrl: './5.component.html',
})
export class VbGeneral5Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
